// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/services/pipelineService.ts
//  Cliente HTTP do CRM Pipeline (estágios + oportunidades + visão kanban).
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type {
  EstagioPipeline,
  CriarEstagioRequest,
  AtualizarEstagioRequest,
  OportunidadeResumo,
  OportunidadeDetalhe,
  CriarOportunidadeRequest,
  AtualizarOportunidadeRequest,
  MoverEstagioRequest,
  FecharOportunidadeRequest,
  VisaoPipeline,
  PaginadoResponse,
} from '../types';

const BASE = '/api/crm/pipeline';

export const pipelineService = {
  // ── Estágios ────────────────────────────────────────────────────────────
  async listarEstagios(): Promise<EstagioPipeline[]> {
    const { data } = await apiClient.get<EstagioPipeline[]>(`${BASE}/estagios`);
    return data;
  },
  async criarEstagio(req: CriarEstagioRequest): Promise<EstagioPipeline> {
    const { data } = await apiClient.post<EstagioPipeline>(`${BASE}/estagios`, req);
    return data;
  },
  async atualizarEstagio(id: number, req: AtualizarEstagioRequest): Promise<EstagioPipeline> {
    const { data } = await apiClient.put<EstagioPipeline>(`${BASE}/estagios/${id}`, req);
    return data;
  },
  async removerEstagio(id: number): Promise<void> {
    await apiClient.delete(`${BASE}/estagios/${id}`);
  },

  // ── Visão Kanban ────────────────────────────────────────────────────────
  async obterVisao(vendedorId?: number): Promise<VisaoPipeline> {
    const { data } = await apiClient.get<VisaoPipeline>(`${BASE}/visao`, {
      params: vendedorId ? { vendedorId } : {},
    });
    return data;
  },

  // ── Oportunidades ───────────────────────────────────────────────────────
  async listar(params: {
    pagina?: number;
    tamanhoPagina?: number;
    estagioId?: number;
    vendedorId?: number;
    somenteAbertas?: boolean;
  } = {}): Promise<PaginadoResponse<OportunidadeResumo>> {
    const { data } = await apiClient.get<PaginadoResponse<OportunidadeResumo>>(
      `${BASE}/oportunidades`,
      { params },
    );
    return data;
  },
  async getById(id: number): Promise<OportunidadeDetalhe> {
    const { data } = await apiClient.get<OportunidadeDetalhe>(`${BASE}/oportunidades/${id}`);
    return data;
  },
  async criar(req: CriarOportunidadeRequest): Promise<OportunidadeDetalhe> {
    const { data } = await apiClient.post<OportunidadeDetalhe>(`${BASE}/oportunidades`, req);
    return data;
  },
  async atualizar(id: number, req: AtualizarOportunidadeRequest): Promise<OportunidadeResumo> {
    const { data } = await apiClient.put<OportunidadeResumo>(`${BASE}/oportunidades/${id}`, req);
    return data;
  },
  async remover(id: number): Promise<void> {
    await apiClient.delete(`${BASE}/oportunidades/${id}`);
  },
  async mover(id: number, req: MoverEstagioRequest): Promise<OportunidadeResumo> {
    const { data } = await apiClient.post<OportunidadeResumo>(
      `${BASE}/oportunidades/${id}/mover`, req,
    );
    return data;
  },
  async fechar(id: number, req: FecharOportunidadeRequest): Promise<OportunidadeResumo> {
    const { data } = await apiClient.post<OportunidadeResumo>(
      `${BASE}/oportunidades/${id}/fechar`, req,
    );
    return data;
  },
};
